import { Component, Input, OnInit } from '@angular/core';
import { CNDepartment } from 'src/app/models/cndepartment';
import { UserDepartmentService } from 'src/app/services/user/user-department.service';

@Component({
  selector: 'app-department',
  templateUrl: './department.component.html',
  styleUrls: ['./department.component.scss']
})
export class DepartmentComponent implements OnInit {

  @Input() department: CNDepartment;

  constructor(private departmentSrv: UserDepartmentService) { }

  ngOnInit(): void {
  }

  public validate() {
    this.departmentSrv.updateDepartment(this.department);
  }
}
